import React, { Component } from 'react'

import { BounceLoader } from 'halogenium'

import { BRAND_COLOR } from '../../../common/styles/colors'

import './style.scss'

export default class Loader extends Component {
  render() {
    const { label, solidBackground } = this.props
    const backGround = solidBackground ? 'loader--solid' : null

    return (
      <div className={`loader ${backGround}`}>
        <BounceLoader color={BRAND_COLOR} size='40px' margin='4px' />
        {label && <h4>{label}</h4>}
      </div>
    )
  }
}
